import { useEffect, useState } from "react"
import {
  DEFAULT_PROFILE_IMAGE,
  resolveProfileImage,
} from "../helpers/profileImage"

/**
 * Resolves a profile/company image URL, falling back to the B2T logo
 * when the source is missing or fails to load.
 */
const useProfileImage = (src) => {
  const [imageSrc, setImageSrc] = useState(() => resolveProfileImage(src))

  useEffect(() => {
    const resolved = resolveProfileImage(src)

    if (!src) {
      setImageSrc(DEFAULT_PROFILE_IMAGE)
      return
    }

    let cancelled = false
    const img = new Image()

    img.onload = () => {
      if (!cancelled) setImageSrc(resolved)
    }
    img.onerror = () => {
      if (!cancelled) setImageSrc(DEFAULT_PROFILE_IMAGE)
    }
    img.src = resolved

    return () => {
      cancelled = true
    }
  }, [src])

  return imageSrc
}

export default useProfileImage
